import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\StoreBrandAuditController::__invoke
* @see app/Http/Controllers/StoreBrandAuditController.php:18
* @route '/brands/{brand}/audits'
*/
export const store = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/brands/{brand}/audits',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\StoreBrandAuditController::__invoke
* @see app/Http/Controllers/StoreBrandAuditController.php:18
* @route '/brands/{brand}/audits'
*/
store.url = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { brand: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { brand: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            brand: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        brand: typeof args.brand === 'object'
        ? args.brand.id
        : args.brand,
    }

    return store.definition.url
            .replace('{brand}', parsedArgs.brand.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\StoreBrandAuditController::__invoke
* @see app/Http/Controllers/StoreBrandAuditController.php:18
* @route '/brands/{brand}/audits'
*/
store.post = (args: { brand: string | { id: string } } | [brand: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

const audits = {
    store: Object.assign(store, store),
}

export default audits